import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICMS, ICMSState } from "./cmsModel";
import {
  cmsActiveInactive,
  createCMS,
  deleteCMS,
  getAllActiveCMS,
  getAllCMS,
  getCMSByID,
  updateCMS,
} from "./services/cms.services";

const initialState: ICMSState = {
  loading: false,
  formLoading: false,
  error: "",
  CMSList: [],
  CMSID: null,
  DeleteImageIndex: -1,
  CMSDetail: {
    Name: "",
    CMSURL: "",
    Template: "",
    MetaDescription: "",
    MetaKeyword: "",
    MetaTitle: "",
    IsActive: 1,
  },
};

const cmsSlice = createSlice({
  name: "cms",
  initialState,
  reducers: {
    clearCMSDetails: (state) => {
      state.CMSDetail = initialState.CMSDetail;
    },
    setCMSID: (state, action) => {
      state.CMSID = action.payload;
    },
    setDeleteImageIndex: (state, action) => {
      state.DeleteImageIndex = action.payload;
    },
    clearCMSID: (state) => {
      state.CMSID = initialState.CMSID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllCMS.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllCMS.fulfilled,
      (state, action: PayloadAction<ICMS[]>) => {
        state.loading = false;
        state.CMSList = action.payload || [];
      }
    );
    builder.addCase(getAllCMS.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CMSList = [];
    });
    builder.addCase(getAllActiveCMS.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveCMS.fulfilled,
      (state, action: PayloadAction<ICMS[]>) => {
        state.loading = false;
        state.CMSList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveCMS.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CMSList = [];
    });
    builder.addCase(createCMS.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createCMS.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createCMS.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateCMS.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateCMS.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateCMS.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteCMS.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCMS.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCMS.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(cmsActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(cmsActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(cmsActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getCMSByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getCMSByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.CMSDetail = action.payload;
    });
    builder.addCase(getCMSByID.rejected, (state, action) => {
      state.loading = false;
      state.CMSDetail = initialState.CMSDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearCMSDetails, setCMSID, clearCMSID, setDeleteImageIndex } =
  cmsSlice.actions;
export default cmsSlice.reducer;
